import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

/**
 * Record last access time of each tenant/zone in local storage
 */
export const recordAccessTimes = store.effects.create((feature: Feature) =>
  rxjs.merge(
    ...models.ScopedAlias.Scope.ALL.map(scope =>
      feature.selectors[`${scope}Alias`].asObservable.pipe(
        rxjs.map(alias =>
          alias
            ? feature.localStorage.actions.putInLastAccessTimesByAlias
                .from('recordAccessTimes (effect)')
                .create({
                  key: models.ScopedAlias.from(scope, alias),
                  value: Date.now(),
                })
            : store.effects.SKIP,
        ),
      ),
    ),
  ),
)
